export const LOAD_EVALUATE = 'LOAD_EVALUATE'
export const LOAD_EVALUATES = 'LOAD_EVALUATES'
export const SET_RECORD_ID = 'SET_RECORD_ID'
export const SET_USER_PROPERTY = 'SET_USER_PROPERTY'
export const LOAD_SESSION = 'LOAD_SESSION'
export const SET_VIEW_TYPE = 'SET_VIEW_TYPE'
export const ADD_COMPARE_RESUME = 'ADD_COMPARE_RESUME'
export const REMOVE_COMPARE_RESUME = 'REMOVE_COMPARE_RESUME'
export const CLEAR_COMPARE_RESUMES = 'CLEAR_COMPARE_RESUMES'
export const HIDE_COMPARE_RESUMES_BAR = 'HIDE_COMPARE_RESUMES_BAR'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js